import { GridColDef } from '@mui/x-data-grid-premium';
import { useAppSelector } from 'store/store';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { NotOperatorRoles } from 'shared/permissions/roles';
import { supplierService } from '../api/SupplierService';
import { SuppliersColumns } from '../suppliers';

export const Suppliers = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.supplier.list';
  const sap_active = useAppSelector((state) => state.auth.sap_active);
  const groups = useAppSelector((state) => state.auth.groups);

  const columns: GridColDef[] = SuppliersColumns(
    sap_active,
    NotOperatorRoles.some((role) => groups.includes(role))
  );

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      pageType="suppliers"
      menuRight={<AddEnhancedButton prefix={translationPrefix} to="new" requireTenantAdmin />}>
      <EnhancedDataGrid columns={columns} service={supplierService} disableExport={true} />
    </TenantPage>
  );
};

export default Suppliers;
